<script setup lang="ts">
import { ElInputNumber } from 'element-plus'

/**
 * The stepper, for a field the form holds as a number. `Input` with `type="number"` is
 * not the same field: it emits a string and leaves the parse to the caller.
 *
 * A cleared field emits **`null`**, not the `undefined` Element Plus gives — `null` is
 * what a zod schema and a filter draft can both hold, so a required field writes
 * `$event ?? 0` rather than treating an empty box as unchanged.
 *
 * `controls`, `precision` and `placeholder` are undeclared here and still work: the root
 * is the control, so they fall through to `ElInputNumber`.
 */
defineProps<{
  modelValue?: number | null
  min?: number
  max?: number
  step?: number
  disabled?: boolean
  size?: 'small' | 'default' | 'large'
  block?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: number | null): void
}>()
</script>

<template>
  <ElInputNumber
    class="shared-input-number"
    :class="{ 'shared-input-number--block': block }"
    :model-value="modelValue ?? undefined"
    :min="min"
    :max="max"
    :step="step"
    :disabled="disabled"
    :size="size"
    v-bind="$attrs"
    @update:model-value="emit('update:modelValue', $event ?? null)"
  />
</template>

<style lang="scss" scoped>
.shared-input-number--block {
  width: 100%;
}
</style>
